<template>
<div class="container-fluid" >

<div v-if="type =='A'">

    <scanner @update="setBarcode"></scanner>
    <div class="card border-primary">
    <div class="card-header text-white bg-primary">
    <h4><i class="fas fa-camera mr-2" aria-hidden="true"></i>STOCK SMART</h4>
    </div> 
    <div style="color:black" class="card-body"> 
    <div class="col-md-4">
    </div>

    <div class="btn-group-vertical">
 
    <button type="button"  @click="item={},msg.title=''"  data-toggle="modal"  data-target="#livestream_scanner" class="btn btn-warning mt-2 ">
            <span class="fas fa-camera mr-2" aria-hidden="true"></span>
            SCANSIONE BARCODE 
            <span v-if="spinner1" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
    </button>

    
    </div>
    </div>  
    </div>
    <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>  
</div>

<div v-else>
     <stock @close="type = 'A'" v-bind:item="item" />
</div>    
  
</div>


</template>
<script>

import api               from "@/api"
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';
import scanner           from '@/components/common/QuaggaScanner.vue'; 
import stock             from '@/components/product/productStock.vue'
import scannerDetection     from '@/scanner';  


export default {
  components: {alertBox,scanner,stock},
  data() {
    return {

      type            : 'A',  
      item            : {},
      

  
      spinner1        : false,
        
      msg             : {

        title     : '',
        body      : '',
        type      : 0

      },
           
    };
  },

  computed :{
    ...mapGetters(['storeId','company']),
   
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {

    $(document).scannerDetection(data => 
    {
   
     onReceive:
     onComplete:
      
      if (data.length == 13)
      { 
       
        this.setBarcode(data)
        
      }

    });






  },
  beforeDestroy () {
       
      $(document).scannerDetection(false);

  },
  created: function() {},
  methods: {
    setBarcode(barcode)    
    {   
        this.dataProduct(barcode)
    },  
    
    async dataProduct(barcode)
    {
    
    this.item = {}  
    this.msg.title = '' 
    this.spinner1  = true
    const sp        = {'sp' : 'spDataProductByBarcode'}
    
    const data      = {'barcode' : barcode ,'storeId' : this.storeId} 
    const json      = Object.assign(data, sp)
          
  await api.post(json).then(res => {
	if(res.status==200)
    {
     if(res.data.recordsets[0].length==0)
          {
            this.msg.title = "ATTENZIONE ! "
            this.msg.body  = "PRODOTTO INESISTENTE."
            this.msg.type  = 1
           
            
            return
          }
          
          this.item = res.data.recordsets[0][0]
         
          this.type = 'B'            
    }
    else if(res.status==500)
    {
    	this.msg.title = 'ATTENZIONE '
      this.msg.body = res.data
      this.msg.type  = 1
    } 
    else
    {
      this.msg.title = 'ATTENZIONE '
      this.msg.body = res
      this.msg.type  = 1               
    } 
}).catch(err => 
{
  this.msg.title = 'ATTENZIONE '
  this.msg.body = err.message
  this.msg.type  = 1
  

}).finally(() => {
	this.spinner1 = false
});



        
  
    },
   
   
}

    
}
</script>
<style scoped>

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.card-header
{
  height: 45px;
}
</style>